import { MINUTES_IN_DAY, MINUTES_IN_HOUR, MINUTES_IN_MONTH } from '../constants/time';
// Decomposes total minutes into months/days/hours/minutes.
// Days are used only when totalMinutes > MINUTES_IN_DAY (i.e. strictly above 24 h).
// Months are used only when totalMinutes > MINUTES_IN_MONTH (i.e. strictly above 30 d).
export const decomposeDuration = (totalMinutes) => {
    const months = totalMinutes > MINUTES_IN_MONTH ? Math.floor(totalMinutes / MINUTES_IN_MONTH) : 0;
    const remainAfterMonths = totalMinutes - months * MINUTES_IN_MONTH;
    const days = totalMinutes > MINUTES_IN_DAY ? Math.floor(remainAfterMonths / MINUTES_IN_DAY) : 0;
    const remainAfterDays = remainAfterMonths - days * MINUTES_IN_DAY;
    const hours = Math.floor(remainAfterDays / MINUTES_IN_HOUR);
    const minutes = remainAfterDays % MINUTES_IN_HOUR;
    return { months, days, hours, minutes };
};
